import React, { useEffect, useState } from 'react'
// Redux
import { Link } from "react-router-dom"
// actions
import { useDispatch, useSelector, shallowEqual } from "react-redux"
import { getCoordinations } from "../../../store/catalogs/Coordinations/actions"
import { getCustomers } from "../../../store/catalogs/Customers/actions"
import { getKinds } from "../../../store/catalogs/Kinds/actions"
import { getLabAreas } from "../../../store/catalogs/LabAreas/actions"
import { getLabSegments } from "../../../store/catalogs/LabSegments/actions"
import { getLocations } from "../../../store/catalogs/Locations/actions"
import { getProducts } from "../../../store/catalogs/Products/actions"
import { getRegions } from "../../../store/catalogs/Regions/actions"
import { getUnitMeasures } from "../../../store/catalogs/UnitMeasures/actions"
import { getUsers } from "../../../store/catalogs/Users/actions"
import { getLabRequestSamples } from "../../../store/labCitec/labRequestSamples/actions"

import { BackButton } from '../../../components/Common/BackButton'
import { BaseCustomButton, sampleMode } from '../../../shared'
import { Expander } from '../../../components/Common/Expander'
import { SearchBar } from '../../../components/Common/SearchBar'
import Table1 from "../../../components/Common/TableContainer"
import baseUrl from '../../../helpers/baseurl'

import moment from 'moment'
import QRCode from 'qrcode.react'
import "react-toastify/dist/ReactToastify.css"
import { staticRoutes } from '../../../routes/staticRoutes'
import { CreateSamplesModal } from './CreateSamplesModal'
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '../../../constants/tables'
import { labRequestSampleStep } from '../../../shared/config/labRequestSampleSteps'

export const SampleLaboratoryTable = ({ props, lab, labName }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isClone, setIsClone] = useState(false);
  const [rowInfo, setRowInfo] = useState();
  const [params2, setParams2] = useState(`?limit=${DEFAULT_PAGE_SIZE}&page=${DEFAULT_PAGE}`);
  const [filterQuery, setFilterQuery] = useState('');
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

  // * Redux
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCoordinations(`?limit=100&page=${DEFAULT_PAGE}`))
    dispatch(getLabSegments(`?limit=100&page=${DEFAULT_PAGE}`))
    dispatch(getProducts(`?limit=100&page=${DEFAULT_PAGE}`))
    dispatch(getCustomers(`?limit=100&page=${DEFAULT_PAGE}`))
    dispatch(getUnitMeasures(`?limit=100&page=${DEFAULT_PAGE}`))
    dispatch(getRegions(`?limit=5000&page=${DEFAULT_PAGE}`))
    dispatch(getLocations(`?limit=5000&page=${DEFAULT_PAGE}`))
    dispatch(getKinds(`?limit=100&page=${DEFAULT_PAGE}`))
    dispatch(getUsers(`?limit=100&page=${DEFAULT_PAGE}&recordStatus=enable`))
  }, [])

  useEffect(() => {
    setFilterQuery('')
    setPageSize(DEFAULT_PAGE_SIZE)
    setParams2(`?limit=${DEFAULT_PAGE_SIZE}&page=${DEFAULT_PAGE}`)
    dispatch(getLabRequestSamples(`?limit=${DEFAULT_PAGE_SIZE}&page=${DEFAULT_PAGE}&step=${labRequestSampleStep.sampleControl}&laboratoryType=${lab}`))
    dispatch(getLabAreas(`?limit=100&page=${DEFAULT_PAGE}&search=${labName}`))
  }, [lab])

  const { coordinations, labsegments, labareas, customers, locations, regions,
    unitmeasures, kinds, labRequestSamples, loading, users, currentPage, total, } = useSelector(state => ({
      advisers: state.technicalAdvisers.technicalAdvisers,
      coordinations: state.coordinations.coordinations,
      labsegments: state.labSegments.labsegments,
      labareas: state.labAreas.labareas,
      products: state.products.products,
      customers: state.customersReducer.customers,
      locations: state.locations.locations,
      regions: state.regions.regions,
      unitmeasures: state.unitMeasures.unitmeasures,
      kinds: state.kinds.kinds,
      labRequestSamples: state.labRequestSampleReducer.labRequestSamples,
      labRequestSample: state.labRequestSampleReducer.labRequestSample,
      loading: state.labRequestSampleReducer.loading,
      total: state.labRequestSampleReducer.total,
      currentPage: state.labRequestSampleReducer.currentPage,
      users: state.usersReducer.users,
    }), shallowEqual);
  // * Redux fin

  const columns = React.useMemo(
    () => [
      Expander,
      {
        Header: 'Código',
        width: '7%',
        Cell: ({ row }) => (
          <div>
            <div className='text-center mb-3'>
              <QRCode value={row.original.sampleControlIdentifier ?? ''} size={90} />
            </div>
            <div className='text-center'><b>No.: </b> {row.original.sampleControlIdentifier ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Solicitud de Servicios',
        width: '10%',
        Cell: ({ row }) => (
          <div>
            <div className='text-center'><b> {(row.original.sampleType === 'internal') ? row.original.code ?? '-' : row.original.labRequest?.code ?? ''} </b></div>
          </div>
        ),
      },
      {
        Header: 'Detalle',
        width: '15%',
        Cell: ({ row }) => (
          <div>
            <div className='text-left'><b>Cliente: </b>{(row.original.sampleType === 'internal') ? row.original.customer?.name ?? '-' : row.original.labRequest?.customer?.name ?? ''}</div>
            <div className='text-left'><b>Asesor Técnico: </b> {(row.original.sampleType === 'internal') ? `${row.original.senderUser?.name} ${row.original.senderUser?.surname}` ?? '-' : `${row.original.labRequest?.technicalAdviser?.name} ${row.original.labRequest?.technicalAdviser?.surname}` ?? '-'}</div>
            <hr className='text-success' />
            <div className='text-left'><b>Tipo de Laboratorio: </b> {(row.original.sampleType === 'internal') ? row.original.laboratoryArea?.laboratoryType?.name ?? '-' : row.original.labRequest?.laboratoryArea?.laboratoryType?.name ?? '-'} </div>
            <div className='text-left'><b>Área de Laboratorio: </b>{(row.original.sampleType === 'internal') ? row.original.laboratoryArea?.name ?? '-' : row.original.labRequest?.laboratoryArea?.name ?? '-'} </div>
            <div className='text-left'><b>Coordinación: </b> {(row.original.sampleType === 'internal') ? row.original.coordination?.name ?? '-' : row.original.labRequest?.coordination?.name ?? '-'}</div>
            <div className='text-left'><b>Segmento: </b> {(row.original.sampleType === 'internal') ? row.original.laboratorySegment?.name ?? '-' : row.original.labRequest?.laboratorySegment?.name ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Datos de la Muestra',
        width: '20%',
        Cell: ({ row }) => (
          <div>
            <div className='text-left'><b>Clase: </b> {row.original.kind?.name ?? '-'}</div>
            <div className='text-left'><b>Descripción: </b> {row.original.name ?? '-'}</div>
            <div className='text-left'><b>Cantidad: </b>{row.original.quantity ?? '0'}</div>
            <div className='text-left'><b>UM: </b>{row.original.unitMeasure?.name ?? '-'}</div>
            <hr className='text-success' />
            <div className='text-left'><b>Tipo de Ensayo: </b> {row.original.observations ?? '-'}</div>
            <div className='text-left'><b> Recibe: </b> {row.original.receiverUser?.name ?? ''} {row.original.receiverUser?.surname ?? ''}</div>
            <div className='text-left'><b> Localidad: </b>{row.original.region?.municipality ?? ''}-{row.original.region?.state ?? ''}</div>
          </div>
        ),
      },
      {
        Header: 'Fechas de Atención',
        width: '20%',
        Cell: ({ row }) => (
          <div>
            <div className='text-left'><b>Fecha de muestreo: </b></div>
            <div className='text-left'>{row.original.dateAt ? moment(row.original.dateAt).utc().format('YYYY-MM-DD') : '-'}</div>
            <div className='text-left'><b>Fecha Estimada de Recepción: </b></div>
            <div className='text-left'>{row.original.estimateReceivedAt ? moment(row.original.estimateReceivedAt).utc().format('YYYY-MM-DD') : '-'}</div>
            <hr className='text-success' />
            <div className='text-left'><b>Fecha de Recepción: </b></div>
            <div className='text-left'>{row.original.receivedAt ? moment(row.original.receivedAt).utc().format('YYYY-MM-DD') : '-'}</div>
            <div className='text-left'><b>Fecha de Desecho: </b></div>
            <div className='text-left'>{row.original.wastedAt ? moment(row.original.wastedAt).utc().format('YYYY-MM-DD') : '-'}</div>
          </div>
        ),
      },
      {
        width: '8%',
        Header: "Acciones",
        Cell: ({ row }) => (
          <div className="page-title-box d-flex align-items-center justify-content-center row">
            <BaseCustomButton
              color='primary'
              outline
              className="col-10 mb-2 p-1"
              icon="mdi-printer mdi-18px"
              label="Imprimir"
              tag={Link}
              to={{
                pathname: `${staticRoutes.labRequestSamples.printView}/${row.original.id}`,
                query: {
                  data: row.original,
                }
              }}
            />
            {row.original.sampleType === 'internal' && (
              <BaseCustomButton
                color='primary'
                outline
                className="col-10 mb-2 p-1"
                icon="mdi-lead-pencil mdi-18px"
                label="Editar"
                onClick={() => onEdit(row.original)}
              />
            )}
            <BaseCustomButton
              color='primary'
              outline
              className="col-10 p-1"
              icon="mdi-content-copy mdi-18px"      //? mdi-file-multiple
              label="Clonar"
              onClick={() => onClone(row.original)}
            />
          </div>
        ),
      },
    ],
    []
  )

  const onEdit = (values) => {
    setIsUpdate(true);
    setIsClone(false);
    setRowInfo(values);
    setIsModalVisible(true);
  }

  const onClone = (values) => {
    setIsUpdate(false);
    setIsClone(true);
    setRowInfo(values);
    setIsModalVisible(true);
  }

  const onSearch = (term) => {
    const query = `&search=${term}`;
    setFilterQuery(query);
    dispatch(getLabRequestSamples(`?limit=${pageSize}&page=${DEFAULT_PAGE}${query}&step=${labRequestSampleStep.sampleControl}&laboratoryType=${lab}`));
    setParams2(`?limit=${pageSize}&page=${DEFAULT_PAGE}`);
  }

  const getPagination = (params) => {
    setParams2(params);
    dispatch(getLabRequestSamples(`${params}${filterQuery}&step=${labRequestSampleStep.sampleControl}&laboratoryType=${lab}`));
  }

  const renderRowSubComponent = React.useCallback(
    ({ row }) => (
      <div>
        <div className='text-left'>Observaciones: {row?.original?.observations ?? '-'}</div>
      </div>
    ),
    []
  )

  const modalClose = () => {
    setIsUpdate(false);
    setIsClone(false);
  }

  return (
    <React.Fragment>
      <div>
        <h5> BITÁCORA DE RECEPCIÓN DE MUESTRAS, QUÍMICOS, MATERIALES DE REFERENCIA Y AUXILIARES </h5>
        <div className='pe-1'>
          <BackButton props={props} />
        </div>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 col-xxl-8 mb-2 ps-3 pe-2">
            <SearchBar setSearchData={onSearch} />
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 col-xxl-2 pe-2">
            <Link
              to={{
                pathname: `${baseUrl}lab-request-samples/export-to-excel${params2}&laboratoryType=${lab}${filterQuery}`,
              }} target='_blank'
            >
              <button className='btn rounded-3 w-100 pb-2' style={{ backgroundColor: 'green', color: 'white' }}>
                <span className="mdi mdi-22px mdi-file-excel me-2"></span>Exportar
              </button>
            </Link>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 col-xxl-2 pe-2">
            <BaseCustomButton
              label='Nuevo Registro'
              color='success'
              className="btn btn-success py-2 ms-1 w-100 rounded-3"
              icon="mdi mdi-plus me-2"
              onClick={() => setIsModalVisible(true)}
            />
          </div>
        </div>
        <div className='row ps-3 me-0'>
          <Table1
            renderRowSubComponent={renderRowSubComponent}
            currentPage={currentPage}
            getPagination={getPagination}
            total={total}
            loading={loading}
            isAddTableBorderStrap
            columns={columns}
            data={labRequestSamples}
            onPageSizeChange={(newSize) => setPageSize(newSize)}
          />
          <CreateSamplesModal
            users={users}
            labareas={labareas}
            customers={customers}
            labsegments={labsegments}
            coordinations={coordinations}
            kinds={kinds}
            unitMeasures={unitmeasures}
            regions={regions}
            locations={locations}
            rowInfo={rowInfo}
            isUpdate={isUpdate}
            isClone={isClone}
            props={props}
            setShowModal={setIsModalVisible}
            showModal={isModalVisible}
            modalHeader='Registro de Muestras'
            modalClose={modalClose}
            mode={sampleMode.sample}
            laboratoryType={lab}
            pageSize={pageSize}
          />
        </div>
      </div>

    </React.Fragment>
  )

}
